import React, { useEffect } from 'react';
import { Modal, Row } from 'react-bootstrap';
import styleClasses from '../../../../src/containers/order/order.module.scss';
import styles from '../../../components/Header/Header.module.scss';
import {
  DELIVERY_DESTINATION_ID,
  DELIVERY_ORDER_TYPE,
  IN_STORE_DESTINATION_ID,
  REACT_APP_CLOUD_FRONT,
  REACT_APP_IMAGES_VERSION,
  ROUTE_MENU
} from '../../../constants';
import { ISelectedItemDetailsForModal } from '../../../models/try2Combo';
import { setShowCart } from '../../../redux/slices/cartSlice';
import { useAppDispatch, useAppSelector } from '../../../redux/store/store';
import { cartItem } from '../../../models/cart.model';
import ItemScript from '../../../components/scripts/itemScript';
import { useStoreLocation } from '../../../context/StoreLocation';
import UpsellItemCard from '../../../components/Cart/UpsellItems/UpsellItemCard';
import { useAuthState } from '../../../context/UserAuthentication';
import { useNavigate, useLocation } from 'react-router';
import useGetUpsellItemsForAddToOrder from '../../../react-query-hooks/useGetUpsellItemsForAddToOrder';
import useCheckMobileScreen from '../../../hooks/useCheckMobileScreen';
import { useIsDesignV2 } from '../../../hooks/useIsDesignV2';
import { PULSE_VIEW_ID, trackPulseView } from '../../../analytics/pulseViewIds';

interface ModalProps {
  showModal: boolean;
  closeModal: () => void;
  name: string;
  image: string;
  isCombo: boolean;
  comboItems?: ISelectedItemDetailsForModal[];
  styleTitle?: string;
  styleName?: string;
  item: cartItem;
  setshowModal?: any;
  itemFromApi?: any;
  categoryName?:string;
  closeModalAndOpenCart?: () => void;
}
const AddedModal: React.FunctionComponent<ModalProps> = ({
  showModal,
  closeModal,
  name,
  image,
  isCombo,
  comboItems,
  styleTitle,
  styleName,
  item,
  setshowModal,
  itemFromApi,
  categoryName,
  closeModalAndOpenCart
}) => {
  const { authInfo } = useAuthState();
  const { locationInfo } = useStoreLocation();
  const dispatch = useAppDispatch();
  const history = useNavigate();

  const location_id = locationInfo.selectedStore?.id;

  const location: any = useLocation();
  const isItMobile = useCheckMobileScreen();
  const isDesignV2 = useIsDesignV2()
  const { search } = location;
  

  const cart = useAppSelector((state) => state.cart);
  const query = new URLSearchParams(search);

  const category_id = query.get('category_id');

  const {
    data: upselData,
    refetch: fetchUpsell,
    isFetching: isFetchingUpsell,
  } = useGetUpsellItemsForAddToOrder({
    location_id,
    category_id: isCombo ? itemFromApi?.id?.toString() : category_id,
    order_type:
      cart?.orderType === DELIVERY_ORDER_TYPE
        ? DELIVERY_DESTINATION_ID
        : IN_STORE_DESTINATION_ID,
  });

  useEffect(() => {
    showModal && fetchUpsell();
  }, [showModal]);

  // Pulse: fire when Added modal opens (not upsell confirmation variant)
  useEffect(() => {
    if (!showModal) return;
    trackPulseView(PULSE_VIEW_ID.ADDED_TO_CART_MODAL, {
      page_path: location.pathname,
    });
  }, [showModal, location.pathname]);

  const itemImage = comboItems ? (
    <div className=" pt-2 pb-4 row">
      {comboItems?.map((item) => {
        return item?.is_selected ? (
          <div className="col-6">
            <img
              src={`${REACT_APP_CLOUD_FRONT}${item.image}?version=${REACT_APP_IMAGES_VERSION}`}
              className={`img-fluid mb-1 ${styleClasses.img_fluid_border}`}
              alt={item?.itemName}
            />
            <p className="text-center font-rale mt-2 fw-500 f-s18 f-sm-s14">
              {' '}
              {item?.itemName}
            </p>
          </div>
        ) : null;
      })}
    </div>
  ) : (
    <img
      src={image}
      className={`${styleClasses.orderModalImage}`}
      alt="Chocolate-Dipped Strawberry"
    />
  );

  const onContinueClick = () => {
    if (isCombo) {
      closeModal();
    } else {
      history(isDesignV2 ? `${ROUTE_MENU}/${categoryName}` : ROUTE_MENU);
    }
  };

  const onViewCartClick = () => {
    if (isCombo) {
      closeModal();
      dispatch(setShowCart(true));
    } else {
      closeModalAndOpenCart()
    }
  };

  const upSellItems =
    upselData?.length > 0 ? (
      <>
        <h4 className="f-s22 text-center font-Cls lh-30 f-sm-s16">
          {upselData[0].header}
        </h4>
        <Row className={styles.suggestion_row}>
          {upselData?.slice(0, 3)?.map((item, index: number) => (
            <>
              <UpsellItemCard
                key={item.id}
                upSellItem={item}
                btnText={'Add'}
                setshowModal={setshowModal}
                trackFrequentlyBoughtTogether
              />
            </>
          ))}
        </Row>
      </>
    ) : null;

  return (
    <>
      {showModal && (
        <ItemScript
          item={item}
          scriptType={'add_to_cart'}
          location_id={locationInfo?.selectedStore?.id}
          userId={authInfo.userId}
        />
      )}
      <Modal
        show={showModal}
        centered
        className="theme-modal-style app_container_wrap order_type_modal xs-modal border-radius-15 align-sm-bottom added-modal-size"
        onHide={closeModal}
      >
        <Modal.Header className="pt-0">
          <button
            type="button"
            className="btn modal-close-button pe-0"
            onClick={closeModal}
          >
            Close
          </button>
        </Modal.Header>
        <Modal.Body className="px-md-5  pb-lg-5 pb-md-3 pt-1">
          <div className="d-flex flex-column h-100 no-shadow">
            <div className={`${styleClasses.item_title_wrap} menu-title`}>
              <h6 className={`sub_title1 text-center ${styleTitle}`}>
                Added to your cart!
              </h6>
            </div>

            <div
              className={`${styleClasses.item_calor_wrap} menu-calories d-flex justify-content-center`}
            >
              <h6
                className={`f-s18 h-14 clr-dark-grey font-Visby-cf  f-bold mb-2 text-center ${styleName}`}
                data-testid="ItemNameInModal"
              >
                {name}
              </h6>
            </div>
            <hr className="my-1" />
            {itemImage}
          </div>
          {upSellItems}
          <div className="mt-2">
            <button
              type="button"
              className={`btn btn-large position-relative py-2 btn-disabled-bg w-100  ${styleClasses.added_modal_btn}`}
              onClick={() => onViewCartClick()}
            >
              View Cart
            </button>
            <button
              type="button"
              className={`btn btn-large outline mt-2 py-2 w-100 ${styleClasses.added_modal_btn}`}
              onClick={() => onContinueClick()}
            >
              Continue Ordering
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddedModal;
